var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isWide)?[_c('RainWideLayer',{attrs:{"boundsList":_vm.boundsList}})]:_vm._l((_vm.tileLayers),function(layer,key){return _c('LImageOverlay',{key:key,attrs:{"url":layer.url,"bounds":layer.bounds,"opacity":_vm.opacity}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }